<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="mediapipeline-modal">
<!-- <div class="modal-content mediapipeline-modal"> -->
  <p-confirmDialog #cd>
    <ng-template #footer>
      <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
      <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
      <div class="far fa-comment pull-right"
        style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()">
      </div>
    </ng-template>
  </p-confirmDialog>

  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Media Pipeline&nbsp;<i
        *ngIf="!pipelineLoaded" class="fa fa-spinner fa-spin fa-1x fa-fw"></i></h5>
    <button (click)="bsModalRef.hide()" class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div class="modal-body" *ngIf="pipelineLoaded">
    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
      <div class="form-group" style="width: 400px;">
        <label for="owner" style="font-weight: 500;">Pipeline Name</label>
        <input [(ngModel)]="mediaPipelineInfo.name" class="form-control" id="owner" name="owner" required type="text"
          style="height: 38px; border-color: lightgray; color: black;" />
      </div>

      <div class="form-group" style="width: 350px;">
        <label for="mediaSource" style="font-weight: 500;">Media Source</label>
        <!-- The pipeline belongs to the gateway that is checked in Scoutview, so it is shown, not chosen. -->
        <input [value]="selectedImageDevice?.name ?? mediaPipelineInfo.sourceName" class="form-control" id="mediaSource" name="mediaSource" disabled type="text"
          style="height: 38px; border-color: lightgray;" />
      </div>

      <div class="form-group" style="width: 180px;">
        <label for="enabled" style="margin-right: 10px; margin-left: 110px; font-weight: 500;">Active</label>
        <div style="margin-left: 120px; margin-top: 5px;">
          <!-- <p-toggleswitch  id="enabled" [(ngModel)]="mediaPipelineInfo.isActive" [ngModelOptions]="{standalone: true}" (onChange)="updateMediaPipelineActive($event)" required></p-toggleswitch> -->
          <p-toggleswitch id="enabled" [(ngModel)]="mediaPipelineInfo.isActive" [ngModelOptions]="{standalone: true}"
            required></p-toggleswitch>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
      <div class="form-group" style="width: 965px;">
        <label for="owner" style="font-weight: 500;">Description</label>
        <input [(ngModel)]="mediaPipelineInfo.description" class="form-control" id="owner" name="owner" required
          type="text" style="height: 38px; border-color: lightgray; color: black;" />
      </div>
    </div>

    <div class="card" style="margin-bottom: 30px;">
      <div
        style="background-color: #203864; color: white; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">
        Processing Pipeline</div>
      <div class="card-body" style="padding: 0px;">

        <div id="destinationBag" class="processingStepBag bag" dragula="pipeline-steps"
          [(dragulaModel)]="selectedMediaProcessingSteps">
          <div class="row grab mb-2" *ngFor="let step of selectedMediaProcessingSteps">
            <p-panel [header]="step.name" [toggleable]="true">
              <div class="col" *ngFor="let parameter of step.parameters | keyvalue">
                <label>{{parameter.key}}:</label>
                <input type="text" [value]="step.parameters[parameter.key]"
                  (blur)="step.parameters[parameter.key] = $event.target.value" />
              </div>
            </p-panel>
          </div>
          <div class="row" *ngIf="selectedMediaProcessingSteps.length === 0">
            <div style="font-style: italic; color: gray" class="col">Drag steps here, or click + next to a step below, to add it to the pipeline. Drag steps out of the container to remove them.</div>
          </div>
        </div>

      </div>
    </div>

    <div class="card" style="margin-bottom: 15px;">
      <div
        style="background-color: #203864; color: white; font-size: 16px; padding-left: 10px; padding-right: 10px; height: 30px; display: flex; align-items: center; justify-content: space-between;">
        <span>All Available Media Processing Steps</span>
        <span class="step-search">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input [(ngModel)]="stepSearchText" (input)="applyStepFilter()" name="stepSearch" type="text" autocomplete="off"
            placeholder="Search steps" aria-label="Search steps" />
        </span>
      </div>
      <div class="card-body step-scroll" style="padding: 0px;">

        <table class="processingStepTable">
          <thead>
            <tr>
              <th *ngFor="let col of MediaProcessingCols" [ngStyle]="{'width': col.width}"
                style="background-color: var(--kig-section-header-bg); flex: none;">
                {{col.header}}
              </th>
            </tr>
          </thead>
          <tbody id="sourceBag" class="bag" dragula="pipeline-steps" [dragulaModel]="filteredAvailableSteps">
            <tr class="grab" *ngFor="let step of filteredAvailableSteps">
              <td class="no-drag add-step-cell">
                <i class="fa fa-plus add-step" role="button" tabindex="0" title="Add to pipeline" aria-label="Add to pipeline"
                   (click)="addStepToPipeline(step)" (keydown.enter)="addStepToPipeline(step)"></i>
              </td>
              <td>{{ step.id }}</td>
              <td>{{ step.name }}</td>
              <td>{{ step.description }}</td>
              <td>{{ step.inputType }}</td>
              <td>{{ step.outputType }}</td>
              <td>{{ step.parametersAsText }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Outside the drag source: dragula counts the rows of the tbody above, so a message row must not be one of them. -->
        <div *ngIf="filteredAvailableSteps.length === 0 && stepSearchText.trim() !== ''" class="step-no-match">
          No steps match "{{ stepSearchText.trim() }}"
        </div>

      </div>
    </div>

    <div style="display:block; margin-left: 10px; margin-right: 10px; ">
      <button (click)="updatePipeline(bsModalRef)" style="height: 38px; width: 100px; float: right; margin-left: 20px;"
        class="btn btn-success" type="button">{{createOrUpdateTag}}</button>
      <button (click)="bsModalRef.hide()" style="height: 38px; width: 125px; float: right; margin-bottom: 15px;" class="btn btn-basic" type="button">Cancel</button>
    </div>

  </div>
</div>


<ng-template #loading>
  <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    <span>Loading...</span>
  </div>
</ng-template>